import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Typography } from "@mui/material";
import type { AnalyzedMoveResult } from "@/shared/api/engine.api";

interface GameChatContextControlProps {
  currentMove: AnalyzedMoveResult | null;
  pinnedMove: AnalyzedMoveResult | null;
  disabled: boolean;
  onPin: (move: AnalyzedMoveResult) => void;
  onClear: () => void;
}

const sameMove = (left: AnalyzedMoveResult | null, right: AnalyzedMoveResult | null): boolean => {
  if (!left || !right) return false;
  return left.moveNumber === right.moveNumber && left.isPlayerMove === right.isPlayerMove && left.san === right.san;
};

export const GameChatContextControl = ({
  currentMove,
  pinnedMove,
  disabled,
  onPin,
  onClear,
}: GameChatContextControlProps) => (
  <Box sx={{ minHeight: 44, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5 }}>
    <Typography sx={{ color: "text.secondary", fontSize: ".6rem", fontWeight: 900, letterSpacing: ".08em" }}>
      THIS GAME
    </Typography>
    {pinnedMove && (
      <Box
        sx={{
          minHeight: 44,
          display: "flex",
          alignItems: "center",
          border: "1px solid",
          borderColor: "secondary.main",
          bgcolor: "rgba(245,188,64,.08)",
        }}
      >
        <Typography sx={{ pl: 1, color: "secondary.main", fontSize: ".6rem", fontWeight: 900 }}>
          MOVE {pinnedMove.moveNumber} · {pinnedMove.san}
        </Typography>
        <IconButton
          aria-label={`Remove move ${pinnedMove.moveNumber} from Nikola context`}
          disabled={disabled}
          onClick={onClear}
          size="small"
          sx={{ width: 44, height: 44, color: "secondary.main" }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    )}
    {currentMove && !sameMove(currentMove, pinnedMove) && (
      <Button
        disabled={disabled}
        onClick={() => onPin(currentMove)}
        sx={{ minHeight: 44, px: 1, fontSize: ".58rem", fontWeight: 900, letterSpacing: ".06em" }}
      >
        {pinnedMove ? `UPDATE TO MOVE ${currentMove.moveNumber}` : `MARK MOVE ${currentMove.moveNumber}`}
      </Button>
    )}
  </Box>
);
